import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { getTextDate } from 'utils/formattedData';

import type IMaterialityAssessmentTableRows from '../interfaces/IMaterialityAssessmentTableRows';

function MaterialityAssessmentTableRows({
  listMA,
  selectedItemId,
  onItemSelect,
  styles,
}: IMaterialityAssessmentTableRows) {
  const { t } = useTranslation();
  return (
    <>
      {listMA.map((item) => (
        <tr
          key={`ma-${item.id}`}
          className={clsx(styles.tableRow, {
            [styles.selected]: selectedItemId === item.id,
          })}
          onClick={() => onItemSelect(item)}
          onKeyDown={() => onItemSelect(item)}
          tabIndex={0}
          role="button"
          aria-label={`Select ${item.name}`}
        >
          <td className={styles.nameCell}>{item.name}</td>
          <td className={styles.dateCell}>
            {item.createdAt
              ? <div>{getTextDate(item?.createdAt)}</div> : null}
            <div className={styles.byAuthor}>
              {item?.createdBy?.firstName && item?.createdBy?.lastName
                ? `by ${item?.createdBy?.firstName} ${item?.createdBy?.lastName}` : ''}
            </div>
          </td>

          <td className={styles.dateCell}>
            {item.updatedAt
              ? <div>{getTextDate(item?.updatedAt)}</div> : null}
            <div className={styles.byAuthor}>
              {item?.updatedBy?.firstName && item?.updatedBy?.lastName
                ? `by ${item?.updatedBy?.firstName} ${item?.updatedBy?.lastName}` : ''}
            </div>
          </td>

          <td className={styles.statusCell}>
            <span
              className={clsx(
                styles.statusBadge,
                styles[item?.status?.toLowerCase()],
              )}
            >
              {item.status ? t(`common.${item.status}`) : ''}
            </span>
          </td>
        </tr>
      ))}
    </>
  );
}

export default MaterialityAssessmentTableRows;
